import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CLIENT_APP_ID, ClientAppId } from '@sc/data-access-models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientAppIdInterceptor implements HttpInterceptor {
  constructor(
    @Inject(CLIENT_APP_ID) private readonly clientAppId: ClientAppId
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(
      request.clone({
        setHeaders: { 'x-client-app-id': this.clientAppId?.toLowerCase() },
      })
    );
  }
}
